<template>
  <div>
    <!-- <el-steps :active="active" align-center>
      <el-step title="Details">
      </el-step>
      <el-step title="Send Email">
      </el-step> -->
      <!-- <el-step v-if="!requestCustomer" title="Add Bank account">
      </el-step> -->
    <!-- </el-steps> -->
    <!-- <div v-if="active === 0"> -->
      <el-button
        type="primary"
        @click="sendEmail"
        :loading="loading"
        size="small">
        Request Customer to add payment method.
      </el-button>
    <!-- </div> -->
    <!-- <div v-if="active ===1">
      <el-form>
      </el-form>
    </div> -->
  </div>
</template>

<script>
import axios from 'axios';
import { EMAIL_API_BASE, CRM } from '../env';

export default {
  name: 'NewPaymentMethod',
  props: {
    email: String, required: true,
    firstName: String, required: true,
  },
  data() {
    return {
      requestCustomer: true,
      active: 0,
      loading: false,
    };
  },
  methods: {
    async addBankStep() {
      this.requestCustomer = false;
      this.active = 1;
    },
    async sendEmail() {
      this.loading = true;

      const body = `<mjml>
  <mj-body>
    <mj-section>
      <mj-column>
        <mj-image width="100px" src="https://email-attachments-public.s3.us-east-2.amazonaws.com/rs.png"></mj-image>

        <mj-divider border-color="#F45E43"></mj-divider>

        <mj-text font-size="20px" color="#009aca" font-family="helvetica">Dear ${this.firstName}:</mj-text>

        <mj-text font-size="15px" color="#009aca">The ReadySpaces team kindly requests that you add a new payment method in your member portal.</mj-text>

        <mj-text font-size="15px" color="#009aca">In the United States, we accept ACH payments at no charge, as well as Visa, Mastercard, and Discover for a fee.</mj-text>

        <mj-text font-size="15px" color="#009aca">In Canada, we accept Visa and Mastercard for a fee, as well as Interac E-Transfer at no charge. Please contact your facility manager for details on making E-Transfer payments.</mj-text>

        <mj-text font-size="15px" color="#009aca">We also recommend that you enable autopay functionality for seamless monthly payments, which you can do in your member portal.</mj-text>

        <mj-button href="${CRM}/#?payment=1">Login to ReadySpaces</mj-button>

        <mj-text font-size="15px" color="#009aca">In case you have any questions, please reach out to your facility manager.</mj-text>

        <mj-text font-size="15px" color="#009aca">Thanks,<br/>The ReadySpaces Team</mj-text>
      </mj-column>
    </mj-section>
  </mj-body>
</mjml>`;

      await axios.post(`${EMAIL_API_BASE}/send/email`, {
        from: 'no-reply@api.readyspaces.com',
        to: this.email,
        subject: 'Add your payment details in Readyspaces platform.',
        mjml: true,
        body,
      }, {
        headers: {
          Authorization: `Bearer ${this.$keycloak.token}`,
        },
      });
      this.loading = false;
      this.$emit('done');
    },
  },
};
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/NewPaymentMethod.vue